import styles from "../ConditionalFormItems/ConditionalFormItems.module.scss";

export function ScheduledCallbackFormItems(): JSX.Element {
    return (
        <div className={styles.infoSpan}>
            This will create a Scheduled Callback task. Scheduled Callbacks are typically used for when a contact
            requests a callback at a specific time. They are prioritized above other call tasks in the queue at that
            time.
        </div>
    );
}
